import i18n from "./i18n";

export function getCurrentLanguage(defaultLang){
    return (i18n.language || defaultLang || 'it').split('-')[0];
}